import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'businessSlug'
})
export class BusinessSlugPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
}
